import type { GetProjects200PageAllOfThreeContentItemAuthContext } from './getProjects200PageAllOfThreeContentItemAuthContext';
import type { GetProjects200PageAllOfThreeContentItemBasicInfo } from './getProjects200PageAllOfThreeContentItemBasicInfo';
import type { GetProjects200PageAllOfThreeContentItemFileInfo } from './getProjects200PageAllOfThreeContentItemFileInfo';
import type { GetProjects200PageAllOfThreeContentItemMetaInfo } from './getProjects200PageAllOfThreeContentItemMetaInfo';
import type { GetProjects200PageAllOfThreeContentItemStatsInfo } from './getProjects200PageAllOfThreeContentItemStatsInfo';
import type { GetProjects200PageAllOfThreeContentItemUserInfo } from './getProjects200PageAllOfThreeContentItemUserInfo';
import type { GetProjects200PageAllOfThreeContentItemUserInteraction } from './getProjects200PageAllOfThreeContentItemUserInteraction';

/**
 * 구조화된 단일 프로젝트 응답 데이터
 */
export type GetProjects200PageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  authContext?: GetProjects200PageAllOfThreeContentItemAuthContext;
  /** 프로젝트 기본 정보 */
  basicInfo?: GetProjects200PageAllOfThreeContentItemBasicInfo;
  /** 프로젝트 파일 정보 */
  fileInfo?: GetProjects200PageAllOfThreeContentItemFileInfo;
  /** 프로젝트 메타 정보 */
  metaInfo?: GetProjects200PageAllOfThreeContentItemMetaInfo;
  /** 프로젝트 통계 정보 */
  statsInfo?: GetProjects200PageAllOfThreeContentItemStatsInfo;
  /** 간략한 사용자 정보 */
  userInfo?: GetProjects200PageAllOfThreeContentItemUserInfo;
  /** 현재 사용자와 프로젝트 간의 상호작용 정보 */
  userInteraction?: GetProjects200PageAllOfThreeContentItemUserInteraction;
};
